(function () {
    if(document.querySelector('#booking-form')) {
        import("./BookingForm")
        .then(({BookingForm}) => {
            new BookingForm(document.querySelector('#booking-form'))
        })
    }
    if(document.querySelector('#booking-form-standalone')) {
        import("./BookingForm")
        .then(({BookingForm}) => {
            new BookingForm(document.querySelector('#booking-form-standalone'))
        })
    }
    if(document.querySelector('#booking-table-form')) {
        import("./BookingTableForm")
        .then(({BookingTableForm}) => {
            new BookingTableForm(document.querySelector('#booking-table-form'))
        })
    }
})()